import { ReactNode } from "react";

import { Column, SCROLL_WIDTH } from "@bridgesplit/ui";
import { useTokenListQuery, useInvalidateOnWalletChange, useSyncWalletStore } from "@bridgesplit/abf-react";
import { useMaintainCssTheme, useMaintainDialectTheme } from "@bridgesplit/react";
import { ALLOWED_FEATURES } from "@bridgesplit/utils";

import AppAlertBanner from "./AppAlertBanner";
import { useSetMixpanel } from "../../hooks";

export default function AppWrapper({ children }: { children: ReactNode }) {
    //mixpanel setup
    useSetMixpanel();

    // wallet store sync
    useSyncWalletStore();
    useInvalidateOnWalletChange();

    // prefetch token list on app load
    useTokenListQuery(undefined, { skip: ALLOWED_FEATURES.currentlyDownForMaintenance });
    useMaintainCssTheme();
    useMaintainDialectTheme();

    return (
        <Column
            id="app-wrapper"
            sx={{
                height: "100%",
                minHeight: "100vh",
                width: `calc(100vw - ${SCROLL_WIDTH})`
            }}
        >
            <AppAlertBanner />
            {children}
        </Column>
    );
}
